module.exports = __webpack_public_path__ + "img/GEG.ff6a1022.png";